import { useState, useEffect } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";

export const NavBar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 50);
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [])

  const goHome = () => {
    setExpanded(false);
    if (location.pathname === '/') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      navigate('/');
    }
  }

  const goToContact = () => {
    setExpanded(false);
    if (location.pathname !== '/') {
      navigate('/');
    }
    document.getElementById('footer')?.scrollIntoView({ behavior: 'smooth' });
  }

  return (
    <Navbar
      expand="md"
      className={scrolled ? "scrolled" : ""}
      expanded={expanded}
      onToggle={(expanded) => setExpanded(expanded)}
    >
      <Container className="nav-pill-container">
        <span className="navbar-brand" onClick={goHome}>ARNAV PANJLA</span>
        <Navbar.Toggle aria-controls="basic-navbar-nav">
          <span className="navbar-toggler-icon"></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto nav-links">
            <Nav.Link className={location.pathname === '/' ? 'active navbar-link' : 'navbar-link'} onClick={goHome}>Home</Nav.Link>
            <Nav.Link className={location.pathname === '/about' ? 'active navbar-link' : 'navbar-link'} onClick={() => { setExpanded(false); navigate('/about'); }}>About</Nav.Link>
            <button className="nav-contact-btn" onClick={goToContact}>Contact</button>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  )
}
